if(document.querySelector('.section--textmedia-expand')) {
    document.querySelectorAll('.section--textmedia-expand').forEach(item => {
        item.querySelector('button').addEventListener('click', () => {
            item.classList.toggle('active')
    
            if (item.classList.contains('active')) {
                item.querySelector('button span.text').innerHTML = 'weniger anzeigen'
            }
            if (!item.classList.contains('active')) {
                item.querySelector('button span.text').innerHTML = 'mehr anzeigen'
            }
        })
    })
}
